import range from 'lodash-es/range'

import { EMPTY_OBJECT } from '../../../constants/common'
import { WEEK_DAYS, WEEK_FIRST_DAY } from '../../../constants/date'
import { NUMBER_SIZE } from '../../../constants/size'
import { useDateLocale } from '../../../hooks'
import { WeekDay } from '../WeekDay'

import * as styles from './WeekDays.module.css'

/**
 * @typedef {Object} WeekDaysItemProps
 * @property {string} [className]
 * @property {DateLocale} locale
 * @property {NumberSize} size
 * @property {number} value
 */

/**
 * @typedef {Object} WeekDaysProps
 * @property {string} [Element]
 * @property {React.ComponentType<WeekDaysItemProps>} Item
 * @property {string} [className]
 * @property [locale]
 * @property {NumberSize} [size]
 */

/**
 * @param {WeekDaysProps} props
 */
function WeekDays({
  Element = 'div',
  Item = WeekDay,
  className = styles.WeekDays,
  itemProps: {
    className: itemClassName = styles.item,
    ...itemProps
  } = EMPTY_OBJECT,
  size = NUMBER_SIZE.size40,
  ...elementProps
}) {
  const locale = useDateLocale()

  const weekStart = locale.options.weekStartsOn ?? WEEK_FIRST_DAY

  return (
    <Element {...elementProps} className={className}>
      {range(0, 7).map(day => (
        <Item
          {...itemProps}
          className={itemClassName}
          key={day}
          locale={locale}
          size={size}
          value={(weekStart + day) % WEEK_DAYS}
        />
      ))}
    </Element>
  )
}

export default WeekDays
